import * as React from 'react'
import { ComponentProps, ReactNode } from 'react'
import * as _ from 'lodash'
import { CalculatorStoreInstance } from '../stores/CalculatorStore'
import { JawView } from './components/views/JawView'
import { JawRequirementsView } from './components/views/jaw/requirements/JawRequirementsView'
import { JawRecommendationsView } from './components/views/jaw/recommendations/normal/JawRecommendationsView'
import { MaterialView } from './components/views/MaterialView'
import { BoneGraftingView } from './components/views/BoneGraftingView'
import { BoneGraftingTypeView } from './components/views/bone-grafting/BoneGraftingTypeView'
import { OfficesView } from './components/views/OfficesView'
import { PersonalDataView } from './components/views/PersonalDataView'
import { ResultView } from './components/views/ResultView'
import { InsuranceView } from './components/views/InsuranceView'
import { Jaw } from '../shared/Constants'
import { BoneGraftingRequirementView } from './components/views/bone-grafting/BoneGraftingRequirementView'
import { NonRemovableReplacementView } from "./components/views/requirements/NonRemovableReplacementView";
import {AllOn4TypeView} from "./components/views/requirements/AllOn4TypeView";

export type SubRoutesDefinition = { [key: string]: RouteDefinition }

export interface RouteDefinition {
  path: string
  pathMatch: string
  goBackCondition?: (store: CalculatorStoreInstance) => boolean
  render?: (props?: ComponentProps<any>) => ReactNode|null
  component?: React.ComponentClass
  exact?: boolean
  subRoutes?: SubRoutesDefinition
}

const fixedReplacementTypes = ['non_removable', 'all_on_4', 'all_on_6']
const allOn4Types = fixedReplacementTypes.slice(1)

export const Routes = {
  offices: {
    path: '/implantatkostenrechner/praxen/:code',
    pathMatch: '/implantatkostenrechner/praxen/:code',
    render: () => <OfficesView />,
    exact: true
  },
  calculatorUpperJaw: {
    path: '/implantatkostenrechner/oberkiefer',
    pathMatch: '/implantatkostenrechner/oberkiefer',
    render: () => <JawView jaw='upper'/>,
    exact: false,
    subRoutes: {
      requirements: {
        path: '/implantatkostenrechner/oberkiefer',
        pathMatch: '/implantatkostenrechner/oberkiefer',
        render: () => <JawRequirementsView jaw='upper' />
      },
      nonRemovableReplacement: {
        path: '/implantatkostenrechner/oberkiefer/festsitzend',
        goBackCondition: (store: CalculatorStoreInstance) =>
          store.offer.hasJawRequirement('upper')
          && store.offer.getJawRequirement('upper').hasRequirements()
          && fixedReplacementTypes.indexOf(store.offer.getJawRequirement('upper').fullReplacementType) !== -1,
        pathMatch: '/implantatkostenrechner/oberkiefer/festsitzend',
        render: () => <NonRemovableReplacementView jaw='upper' />,
      },
      allOn4: {
        path: '/implantatkostenrechner/oberkiefer/all-on-4',
        goBackCondition: (store: CalculatorStoreInstance) =>
            store.offer.hasJawRequirement('upper')
            && store.offer.getJawRequirement('upper').hasRequirements()
            && allOn4Types.indexOf(store.offer.getJawRequirement('upper').fullReplacementType) !== -1,
        pathMatch: '/implantatkostenrechner/oberkiefer/all-on-4',
        render: () => <AllOn4TypeView jaw='upper' />,
      },
      recommendations: {
        path: '/implantatkostenrechner/oberkiefer/empfehlung',
        pathMatch: '/implantatkostenrechner/oberkiefer/empfehlung',
        goBackCondition: (store: CalculatorStoreInstance) =>
          store.offer.hasJawRequirement('upper')
          && store.offer.getJawRequirement('upper').hasRequirements()
          && !store.offer.getJawRequirement('upper').allOn4,
        render: () => <JawRecommendationsView jaw='upper' />
      },
      material: {
        path: '/implantatkostenrechner/oberkiefer/material',
        goBackCondition: (store: CalculatorStoreInstance) =>
          store.offer.hasJawRequirement('upper')
          && store.offer.getJawRequirement('upper').hasRequirements()
          && !store.offer.getJawRequirement('upper').allOn4,
        pathMatch: '/implantatkostenrechner/oberkiefer/material',
        render: () => <MaterialView jaw='upper' />
      },
      boneGrafting: {
        path: '/implantatkostenrechner/oberkiefer/knochenaufbau',
        pathMatch: '/implantatkostenrechner/oberkiefer/knochenaufbau',
        render: () => <BoneGraftingView jaw='upper' />,
        exact: false,
        subRoutes: {
          requirements: {
            path: '/implantatkostenrechner/oberkiefer/knochenaufbau',
            goBackCondition: (store: CalculatorStoreInstance) =>
              store.offer.hasJawRequirement('upper')
              && store.offer.getJawRequirement('upper').hasRequirements(),
            pathMatch: '/implantatkostenrechner/oberkiefer/knochenaufbau',
            render: () => <BoneGraftingRequirementView jaw='upper' />,
          },
          type: {
            path: '/implantatkostenrechner/oberkiefer/knochenaufbau/variante',
            goBackCondition: (store: CalculatorStoreInstance) =>
              store.offer.hasJawRequirement('upper')
              && store.offer.getJawRequirement('upper').hasRequirements()
              && store.offer.getJawRequirement('upper').boneGrafting === 'yes',
            pathMatch: '/implantatkostenrechner/oberkiefer/knochenaufbau/variante',
            render: () => <BoneGraftingTypeView jaw='upper' />
          }
        }
      }
    }
  },
  calculatorLowerJaw: {
    path: '/implantatkostenrechner/unterkiefer',
    pathMatch: '/implantatkostenrechner/unterkiefer',
    render: () => <JawView jaw='lower'/>,
    exact: false,
    subRoutes: {
      requirements: {
        path: '/implantatkostenrechner/unterkiefer',
        pathMatch: '/implantatkostenrechner/unterkiefer',
        render: () => <JawRequirementsView jaw='lower' />
      },
      nonRemovableReplacement: {
        path: '/implantatkostenrechner/unterkiefer/festsitzend',
        goBackCondition(store: CalculatorStoreInstance) {
          const req = store.offer.getJawRequirement('lower')
          console.log(req.hasRequirements(), req.fullReplacementType)
          return store.offer.hasJawRequirement('lower')
            && store.offer.getJawRequirement('lower').hasRequirements()
            && fixedReplacementTypes.indexOf(store.offer.getJawRequirement('lower').fullReplacementType) !== -1
        },
        pathMatch: '/implantatkostenrechner/unterkiefer/festsitzend',
        render: () => <NonRemovableReplacementView jaw='lower' />,
      },
      allOn4: {
        path: '/implantatkostenrechner/unterkiefer/all-on-4',
        goBackCondition: (store: CalculatorStoreInstance) =>
            store.offer.hasJawRequirement('lower')
            && store.offer.getJawRequirement('lower').hasRequirements()
            && allOn4Types.indexOf(store.offer.getJawRequirement('lower').fullReplacementType) !== -1,
        pathMatch: '/implantatkostenrechner/unterkiefer/all-on-4',
        render: () => <AllOn4TypeView jaw='lower' />,
      },
      recommendations: {
        path: '/implantatkostenrechner/unterkiefer/empfehlung',
        pathMatch: '/implantatkostenrechner/unterkiefer/empfehlung',
        goBackCondition: (store: CalculatorStoreInstance) =>
          store.offer.hasJawRequirement('lower')
          && store.offer.getJawRequirement('lower').hasRequirements()
          && !store.offer.getJawRequirement('lower').allOn4,
        render: () => <JawRecommendationsView jaw='lower' />
      },
      material: {
        path: '/implantatkostenrechner/unterkiefer/material',
        pathMatch: '/implantatkostenrechner/unterkiefer/material',
        goBackCondition: (store: CalculatorStoreInstance) =>
          store.offer.hasJawRequirement('lower')
          && store.offer.getJawRequirement('lower').hasRequirements()
          && !store.offer.getJawRequirement('lower').allOn4,
        render: () => <MaterialView jaw='lower' />
      },
      boneGrafting: {
        path: '/implantatkostenrechner/unterkiefer/knochenaufbau',
        pathMatch: '/implantatkostenrechner/unterkiefer/knochenaufbau',
        render: () => <BoneGraftingView jaw='lower' />,
        exact: false,
        subRoutes: {
          requirements: {
            path: '/implantatkostenrechner/unterkiefer/knochenaufbau',
            pathMatch: '/implantatkostenrechner/unterkiefer/knochenaufbau',
            goBackCondition: (store: CalculatorStoreInstance) =>
              store.offer.hasJawRequirement('lower')
              && store.offer.getJawRequirement('lower').hasRequirements(),
            render: () => <BoneGraftingRequirementView jaw='lower' />,
          }
        }
      }
    }
  },
  insurance: {
    path: '/implantatkostenrechner/versicherung',
    pathMatch: '/implantatkostenrechner/versicherung',
    component: InsuranceView
  },
  personalData: {
    path: '/implantatkostenrechner/persoenliche-daten',
    pathMatch: '/implantatkostenrechner/persoenliche-daten',
    component: PersonalDataView
  },
  result: {
    path: '/implantatkostenrechner/ergebnis',
    pathMatch: '/implantatkostenrechner/ergebnis/:code?',
    component: ResultView
  },
  getJawRoute: (jaw: Jaw): RouteDefinition => {
    return Routes[`calculator${_.startCase(jaw)}Jaw`]
  }
}

export const RoutesInOrder: RouteDefinition[] = [
  Routes.calculatorUpperJaw.subRoutes.requirements,
  Routes.calculatorUpperJaw.subRoutes.nonRemovableReplacement,
  Routes.calculatorUpperJaw.subRoutes.allOn4,
  Routes.calculatorUpperJaw.subRoutes.recommendations,
  Routes.calculatorUpperJaw.subRoutes.material,
  Routes.calculatorUpperJaw.subRoutes.boneGrafting.subRoutes.requirements,
  Routes.calculatorUpperJaw.subRoutes.boneGrafting.subRoutes.type,
  Routes.calculatorLowerJaw.subRoutes.requirements,
  Routes.calculatorLowerJaw.subRoutes.nonRemovableReplacement,
  Routes.calculatorLowerJaw.subRoutes.allOn4,
  Routes.calculatorLowerJaw.subRoutes.recommendations,
  Routes.calculatorLowerJaw.subRoutes.material,
  Routes.calculatorLowerJaw.subRoutes.boneGrafting.subRoutes.requirements,
  Routes.insurance,
  Routes.personalData,
  Routes.result
]
